import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Dirección" },
  { label: "Dashboard Ejecutivo", icon: "fas fa-tachometer-alt", color: "#2a78d6", bg: "#eff6ff", href: "/DashboardEjecutivo", desc: "Todo el negocio en una pantalla: ventas, cobranza, pedidos y embarques", perm: "menu_reportes" },
  { type: "section", label: "Operación" },
  { label: "Dashboard Compras", icon: "fas fa-cart-plus", color: "#10b981", bg: "#f0fdf4", href: "/DashboardCompras", desc: "Indicadores de compras", perm: "menu_reportes" },
  { label: "Dashboard Inventarios", icon: "fas fa-tshirt", color: "#3b82f6", bg: "#eff6ff", href: "/DashboardInventarios", desc: "Indicadores de inventario", perm: "menu_reportes" },
  { label: "Dashboard Ventas", icon: "fas fa-signal", color: "#f59e0b", bg: "#fffbeb", href: "/DashboardVentas", desc: "Indicadores de ventas", perm: "menu_reportes" },
  { type: "section", label: "Finanzas" },
  { label: "Dashboard CXP", icon: "fas fa-chart-bar", color: "#8b5cf6", bg: "#f5f3ff", href: "/DashboardCXP", desc: "Indicadores de cuentas por pagar", perm: "menu_reportes" },
  { label: "Dashboard Cobranza", icon: "fas fa-dollar-sign", color: "#0ea5e9", bg: "#f0f9ff", href: "/DashboardCobranza", desc: "Indicadores de cobranza", perm: "menu_reportes" },
  { label: "Dashboard Gastos", icon: "fas fa-hand-holding-usd", color: "#f43f5e", bg: "#fff1f2", href: "/DashboardGastos", desc: "Indicadores de gastos", perm: "menu_reportes" },
  { label: "Balance", icon: "fas fa-chart-line", color: "#14b8a6", bg: "#f0fdfa", href: "/Balance", desc: "Balance general", perm: "menu_reportes" },
];

function BotonesDashboards() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-chart-bar" color="#0ea5e9" bg="#f0f9ff" title="Dashboards" subtitle="Tableros gráficos por área" />
        <div className="row">
          {ITEMS.map((r, i) =>
            r.type === "section"
              ? <MenuSection key={i} title={r.label} />
              : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
          )}
        </div>
      </div>
    </>
  );
}

export default BotonesDashboards;
